import type { Dispatch, SetStateAction } from 'react';
import { getChannelsRecallStatus } from '../api/messages';
import { applyRecallStatusToLastMessages } from './chatRecallMessage';
import { normalizePubNubTimetoken } from './pubnubTimetoken';

export type LastMessageWithRecallStatus = {
  timetoken: string | number;
  recalled?: boolean;
};

export async function fetchAndApplyRecallStatusForLastMessages<
  T extends LastMessageWithRecallStatus,
>(
  newState: Record<string, T>,
  setLastMessageList: Dispatch<SetStateAction<Record<string, T>>>,
): Promise<void> {
  const recallItems = Object.entries(newState).map(([channelId, message]) => ({
    channelId,
    timetoken: normalizePubNubTimetoken(message.timetoken),
  }));

  if (recallItems.length === 0) return;

  try {
    const { recalled } = await getChannelsRecallStatus(recallItems);
    if (recalled.length > 0) {
      setLastMessageList((prev) =>
        applyRecallStatusToLastMessages(prev, recalled),
      );
    }
  } catch (error) {
    // Best-effort: previews are already shown, recall labels can be corrected by live refresh.
    console.error('Error fetching recall status for last messages:', error);
  }
}
